// Hlídá, jestli má uživatel ve formuláři rozdělanou práci. Používají to oba
// formuláře (defaultEreceiptForm, dorucovaniLekuVoticeEReceiptForm) a čte to
// App.vue, když se rozhoduje, jestli může sám načíst novou verzi aplikace.

// Zaškrtávátka u eDokumentů jsou předvolby, ne vyplněná data - kvůli nim
// nemá cenu uživatele obtěžovat.
const IGNORED_KEYS = ['allowChangeMedicamentForCheaper', 'allowReleaseAllReps']

export const formUserDataMixin = {
    computed: {
        hasUserData() {
            let formData = this.formData || {}

            return Object.keys(formData).some(key => {
                if (IGNORED_KEYS.indexOf(key) !== -1) {
                    return false
                }

                if (key === 'idBusinessPremise') {
                    return this.isBusinessPremisePickedByUser
                }

                let value = formData[key]

                if (Array.isArray(value)) {
                    return value.length > 0
                }

                if (typeof value === 'boolean') {
                    return value
                }

                return value !== null && value !== undefined && String(value).trim() !== ''
            })
        },

        isBusinessPremisePickedByUser() {
            // Když je v adrese jedna provozovna, vybere se sama - to není volba uživatele
            // a po načtení nové verze se nastaví znovu.
            let provozovny = this.$route.query.provozovny
            let preselected = !!provozovny && provozovny.includes(',') === false

            return !preselected && !!this.formData.idBusinessPremise
        }
    },
    watch: {
        hasUserData: {
            immediate: true,
            handler(hasUserData) {
                this.$store.commit('form/setHasUserData', hasUserData)
            }
        }
    },
    beforeDestroy() {
        this.$store.commit('form/setHasUserData', false)
    }
}
